import { IntegrationsProvider } from '@sdk/integrations/IntegrationsContext';

import BillingView from './BillingView';

const BillingViewAngular = (props) => {
  return (
    <IntegrationsProvider>
      <BillingView {...props} />
    </IntegrationsProvider>
  );
};

export default {
  ReactComponent: BillingViewAngular,
  bindings: {
    billingInfo: '<',
    subscriptionUtils: '<',
    currency: '<',
    currentUser: '<',
    isOldPremium: '<',
    startTrial: '&',
    goToPurchase: '<',
    onBillingInfoUpdated: '<',
    showPricing: '<',
    fromBillingAddressModal: '<',
    goToBilling: '&',
    goToPricing: '&',

    // @INFO we force submit when trying to leave locked screen to show errors
    // since angular handles navigation it needs to be passed down to react
    shouldShowAddressErrors: '<',
  },
};
